<template>
  <tr :class="{'is-clone': row.status_.isClone,'is-new': row.status_.isNew,'is-edit': row.status_.isEdit}">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  name: 'GridRow',
  props: {
    row: { type: Object, required: true }
  },
  data () {
    return {
      animateTimer: null
    }
  },
  watch: {
    row: 'parse'
  },
  mounted () {
    this.parse()
  },
  methods: {
    parse () {
      if (this.animateTimer) {
        clearTimeout(this.animateTimer)
        this.animateTimer = null
      }
      if (this.row.status_.isClone) {
        this.animateTimer = setTimeout(() => {
          this.$emit('handleAnimate', 'isClone', false)
        }, 3000)
      } else if (this.row.status_.isNew) {
        this.animateTimer = setTimeout(() => {
          this.$emit('handleAnimate', 'isNew', false)
        }, 3000)
      } else if (this.row.status_.isEdit) {
        this.animateTimer = setTimeout(() => {
          this.$emit('handleAnimate', 'isEdit', false)
        }, 3000)
      }
    }
  }
}
</script>
